import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    timeCardList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    timeCardDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    workStats: {
        requesting: false,
        data: null,
        error: null,
    },
  };

export const timeCardSlice = createSlice({
  name: 'timeCard',
  initialState,
  reducers: {
    getTimeCardList: (state) => {
        state.timeCardList.requesting = true;
        state.timeCardList.error = null;
        state.timeCardList.items = [];
        state.timeCardList.success = false;
    },
    getTimeCardListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.timeCardList.requesting = false;        
        state.timeCardList.items = data;
        state.timeCardList.success = true; 
        state.timeCardList.pagination.current_page = current_page;
        state.timeCardList.pagination.per_page = per_page;
        state.timeCardList.pagination.total = total;
    },
    getTimeCardListFail: (state, action) => {        
        state.timeCardList.requesting = false;
        state.timeCardList.error = action.payload;
    },
    getTimeCardDetails: (state) => {
        state.timeCardDetails.requesting = true;
        state.timeCardDetails.error = null;
        state.timeCardDetails.data = null;
        state.timeCardDetails.success = false; 
    },
    getTimeCardDetailsSuccess: (state, action) => {
        state.timeCardDetails.requesting = false;
        state.timeCardDetails.data = action.payload;
        state.timeCardDetails.success = true; 
    },
    getTimeCardDetailsFail: (state, action) => {        
        state.timeCardDetails.requesting = false;
        state.timeCardDetails.error = action.payload;
    },
    doTimeCardCreate: (state) => {
        state.timeCardDetails.requesting = true;
        state.timeCardDetails.error = null;
        state.timeCardDetails.data = null;
        state.timeCardDetails.success = false; 
    },
    doTimeCardUpdate: (state) => {
        state.timeCardDetails.requesting = true;
        state.timeCardDetails.error = null;
        state.timeCardDetails.data = null;
        state.timeCardDetails.success = false; 
    },
    doTimeCardDelete: (state) => {
        state.timeCardDetails.requesting = true;
        state.timeCardDetails.error = null;
        state.timeCardDetails.data = null;
        state.timeCardDetails.success = false; 
    },
    getUserTimeCardToday: (state) => {
        state.timeCardDetails.requesting = true;
        state.timeCardDetails.error = null;
        state.timeCardDetails.data = null;
        state.timeCardDetails.success = false; 
    },
    doTimeCardPunch: (state) => {
        state.timeCardDetails.requesting = true;
        state.timeCardDetails.error = null;
        state.timeCardDetails.data = null;
        state.timeCardDetails.success = false; 
    },
    getUserAttendanceStats: (state) => {
      state.workStats.requesting = true;
      state.workStats.error = null;
      state.workStats.data = null;
    },
    getUserAttendanceStatsSuccess: (state, action) => {
      state.workStats.requesting = false;
      state.workStats.data = action.payload;
    },
    getUserAttendanceStatsFail: (state, action) => {
      state.workStats.requesting = false;
      state.workStats.error = action.payload;
    },
  },
})

export const { 
    getTimeCardList, getTimeCardListSuccess, getTimeCardListFail,
    getTimeCardDetails, getTimeCardDetailsSuccess, getTimeCardDetailsFail,
    doTimeCardCreate, doTimeCardUpdate, doTimeCardDelete,
    getUserTimeCardToday, doTimeCardPunch,
    getUserAttendanceStats, getUserAttendanceStatsSuccess, getUserAttendanceStatsFail,
} = timeCardSlice.actions

export default timeCardSlice.reducer